import React, { useState, useEffect } from "react";
import "../style.css";

const FilterSidebar = ({ posts, onFilter }) => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchTerm, setSearchTerm] = useState(""); // Search input state

  // Calculate counts for each category dynamically
  const categoryCounts = posts.reduce(
    (counts, post) => {
      const category = post.category || "Misc";
      counts[category] = (counts[category] || 0) + 1;
      counts["All"] += 1;
      return counts;
    },
    { All: 0 }
  );

  // Debounce function to prevent excessive re-renders
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      onFilter(selectedCategory, searchTerm); // Pass updated filters to parent
    }, 300); // Debounce time (300ms)

    return () => clearTimeout(delayDebounceFn);
  }, [selectedCategory, searchTerm, onFilter]);

  // Handle category change
  const handleFilterChange = (category) => {
    setSelectedCategory(category);
  };

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <div className="filter-sidebar bg-white border-r h-full shadow-md p-4">
      {/* Sidebar Header */}
      <div className="border-b pb-3 mb-3">
        <h3 className="text-xl font-bold">Xebrand</h3>
      </div>

      {/* Search Input */}
      <input
        type="text"
        placeholder="Search..."
        className="w-full p-2 mb-4 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        value={searchTerm}
        onChange={handleSearchChange}
      />

      {/* Categories List */}
      <ul className="text-sm">
        {/* "All" Option */}
        <li
          className={`mb-2 cursor-pointer flex justify-between items-center px-2 py-1 rounded-md ${
            selectedCategory === "All" ? "bg-blue-100 text-blue-600 font-bold" : "text-gray-800"
          }`}
          onClick={() => handleFilterChange("All")}
        >
          <span>All</span>
          <span className="text-gray-500">{categoryCounts["All"]}</span>
        </li>

        {/* Dynamically Generated Categories */}
        {Object.keys(categoryCounts)
          .filter((category) => category !== "All")
          .map((category) => (
            <li
              key={category}
              className={`mb-2 cursor-pointer flex justify-between items-center px-2 py-1 rounded-md ${
                selectedCategory === category ? "bg-blue-100 text-blue-600 font-bold" : "text-gray-800"
              }`}
              onClick={() => handleFilterChange(category)}
            >
              <span>{category}</span>
              <span className="text-gray-500">{categoryCounts[category]}</span>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default FilterSidebar;
